import api from '@/api/services/api'

const getSuppliers = () => api({
  method: 'get',
  url: '/orders/payment/suppliers'
})

const getDetails = params => api({
  method: 'get',
  url: '/orders/payment/details',
  params
})

const getLink = ({ orderId, params }) => api({
  method: 'get',
  url: `/orders/${orderId}/payment/link`,
  params
})

const getInvoice = (orderId, params) => api({
  method: 'get',
  url: `/orders/${orderId}/payment/blank`,
  params
})

export {
  getSuppliers,
  getDetails,
  getLink,
  getInvoice
}